export const DOCUMENT_STYLE_TYPES = {
  SAMPLE_ONE: 'sample-one',
} as const;

export const DOCUMENT_STYLE_OPTIONS = [
  {
    style: DOCUMENT_STYLE_TYPES.SAMPLE_ONE,
  },
] as const;
